import LoaderImage from '../assets/loader.gif'

const Loader  = ()=>{
    return <img src={LoaderImage}  style={{display:'block', margin:'auto'}} alt="" />
}


export default Loader